import React from "react";
import { FaFacebook, FaTwitter, FaInstagramSquare, FaMailBulk } from "react-icons/fa";

require("../../assets/stylesheets/Utils/FootBar.css");

function FootBar() {
  return (
    <nav className="footbar">
      <div className="footOne">
        <a href="https://www.facebook.com/UTHTegucigalpa"
        target="_blank">
          <FaFacebook />
          </a>
        <a href="https://twitter.com/UTHEDU?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor"
        target="_blank">
          <FaTwitter />
          </a>
          <a href="https://www.instagram.com/uthedu/"
          target="_blank">
            <FaInstagramSquare />
          </a>
      </div>
      <div className="footTwo"></div>
      <div className="footThree">
        {" "}
        <a href="mailto:feriasingeniouth@gmail.com">
          <FaMailBulk /> Soporte: Staff Técnico
        </a>{" "}
      </div>
    </nav>
  );
}

export default FootBar;
